module.exports = __webpack_public_path__ + "img/second-left.1a36660d.png";